export default "__VITE_PUBLIC_ASSET__eaced19e__"